import { Modal } from '@iheartjane/reefer';
import { clsx } from 'clsx';

import { ClientOnly } from '@jane/bloom/components/clientOnly';
import type { Cart } from '@jane/bloom/viewModels/cart';

import { BagTransferContent } from './bagTransferContent';

import styles from './bagTransferModal.module.css';

interface BagTransferModalProps {
  newBag: Cart | undefined;
  oldStoreName?: string;
  onConfirm: () => void;
  onRequestClose: () => void;
  open: boolean;
  variant?: 'add-to-cart' | 'checkout';
}

export const BagTransferModal = ({
  newBag,
  oldStoreName,
  onConfirm,
  onRequestClose,
  open,
  variant = 'add-to-cart',
}: BagTransferModalProps) => (
  <ClientOnly>
    {() => (
      <Modal
        variant="dialogue"
        onRequestClose={onRequestClose}
        open={open}
        portalClassName={clsx(
          'ReactModalPortal',
          styles['bagTransferModalPortal']
        )}
      >
        <Modal.Content>
          <BagTransferContent
            newBag={newBag}
            oldStoreName={oldStoreName}
            onCancel={onRequestClose}
            onConfirm={onConfirm}
            variant={variant}
          />
        </Modal.Content>
      </Modal>
    )}
  </ClientOnly>
);
